import { FinancialStatementAccount } from '../../common/FinancialStatementAccount';

export class FinancialStatementAccountDTO {
  id?: number;
  code?: string;
  name?: string;
  isManual?: boolean;
  glTransactionsIds?: number[];
  itemsIds?: number[];

  constructor(id?: number, code?: string, name?: string, isManual?: boolean,
    glTransactionsIds?: number[], financialStatementItemsIds?: number[]) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.isManual = isManual;
    this.glTransactionsIds = glTransactionsIds;
    this.itemsIds = financialStatementItemsIds;
  }

  // conversion loses gl and items!! Needs solution?
  public toEntity(): FinancialStatementAccount {
    return new FinancialStatementAccount(this.id, this.code, this.name, this.isManual);
  }
}
